import moment from 'moment';
import { useRecoilState } from 'recoil';
import { useEffect, useMemo } from 'react';
import { momentLocalizer } from 'react-big-calendar';
import { timeZoneState } from './timeZoneState';
import { useUserTenantPreference, useOrganizationWidePreference } from 'kineticUtils/hooks';
import { PREFERENCE_KEYS } from 'types/preferenceTypes';

type UserPreference = { schedulerTimezone: string | null };
type SystemPreference = UserPreference;

export const useLocalizer = () => {
  const [timeZone, setTimeZone] = useRecoilState(timeZoneState);

  const { value: accountPreference } = useUserTenantPreference<UserPreference>({
    key: PREFERENCE_KEYS.TIMEZONE,
  });

  const { value: organizationPreference } = useOrganizationWidePreference<SystemPreference>({
    key: PREFERENCE_KEYS.TIMEZONE,
  });

  const localizer = useMemo(() => {
    moment.tz.setDefault(timeZone);
    return momentLocalizer(moment);
  }, [timeZone]);

  // Sets timezone based on following heirarchy:
  // User > Organization > Local/Default
  useEffect(() => {
    if (!!accountPreference?.schedulerTimezone) {
      return setTimeZone(accountPreference?.schedulerTimezone);
    }
    if (!!organizationPreference?.schedulerTimezone) {
      return setTimeZone(organizationPreference?.schedulerTimezone);
    }
  }, [setTimeZone, organizationPreference, accountPreference]);

  // Resets timezone for the global moment object
  useEffect(() => {
    return () => {
      moment.tz.setDefault();
    };
  }, []);

  return localizer;
};
